import { render, staticRenderFns } from "./RasConfigurazionePostiLettoPianiListComponent.vue?vue&type=template&id=5512d2d2"
import script from "./RasConfigurazionePostiLettoPianiListComponent.vue?vue&type=script&lang=js"
export * from "./RasConfigurazionePostiLettoPianiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports